// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_XKWKGF_Y","content":"_2ehpxXjv","text":"_YMmnX3ju","image":"_Wp23MPaj"};